import { PropsWithChildren } from "react";

import styles from "@components/Container.module.css";

type Props = PropsWithChildren<{
  className?: string;
}>;

const Container = ({ children, className }: Props) => {
  const wrapperStyles = [styles.container];

  if (className) wrapperStyles.push(className);

  return <div className={wrapperStyles.join(" ")}>{children}</div>;
};

export default Container;
